import { render } from "./GuestBook.vue?vue&type=template&id=5836188d&scoped=true"
import script from "./GuestBook.vue?vue&type=script&lang=js"
export * from "./GuestBook.vue?vue&type=script&lang=js"

import "./GuestBook.vue?vue&type=style&index=0&id=5836188d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5836188d"]])

export default __exports__